<p-dialog
  class="ui-dialog-component"
  [header]="header"
  [styleClass]="'confirm-dialog ' + styleClass"
  [(visible)]="visible"
  (onHide)="onClose($event)"
  (onShow)="onOpen($event)"
  [minY]="minY"
  [modal]="true"
  [maximizable]="maximizable"
  [baseZIndex]="1000000"
  [resizable]="false"
  [closable]="closable"
  [style]="style"
>
  <ng-content></ng-content>
  <p-footer>
    <div class="confirm-dialog__footer">
      <div #customFooter>
        <ng-content select="[footer]"></ng-content>
      </div>
      <div #customFooterElements>
        <ng-content select="[customFooterElements]"></ng-content>
      </div>
      <button
        *ngIf="!customFooter.children.length && !customFooterElements.children.length"
        type="button"
        id="DialogBtnOk"
        class="btn btn__white-with-shadow"
        (click)="onClose(true)"
      >
        ОК
      </button>
    </div>
  </p-footer>
</p-dialog>
